import React from 'react';

import type { StickerColor } from '../../../../../types/dontgiftguide';
import * as styles from './CircleSticker.styles';

export interface CircleStickerProps {
  color: StickerColor;
  content: string;
}

const getImageSrc = (color: StickerColor) => {
  switch (color) {
    case 'yellow':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltf49699288bb28e42/yellow_circle.png';
    case 'purple':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt04a2637768aaf5dc/purple_circle.png';
    case 'green':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt6c69073593847e18/green_circle.png';
    case 'dark purple':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltcf3bd3661232ba14/dark_purple_circle.png';
    case 'dark green':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltabadf35835fa5993/dark_green_circle.png';
    default:
      console.error(`Unsupported circle sticker color: ${color}`);
      return null;
  }
};

export const CircleSticker = ({ color, content }: CircleStickerProps) => {
  const imageSrc = getImageSrc(color);

  return imageSrc ? (
    <div css={styles.container}>
      <img src={imageSrc} alt="" />
      <div
        css={[
          styles.contentWrapper,
          ['dark purple', 'dark green'].includes(color) ? styles.contentLight : styles.contentDark,
        ]}
      >
        <div css={styles.content}>{content}</div>
      </div>
    </div>
  ) : null;
};
